import React from "react";
import ProductsPageLayout from "./ProductsPageLayout";

export default function Table() {
  return (
    <>
      <ProductsPageLayout productCategory="table" />
    </>
  );
}
